import { registerPlugin } from '@capacitor/core';

const Fingerprint = registerPlugin('Fingerprint');

export default Fingerprint;